// src/pages/LoginPage.jsx

import React, { useEffect } from "react";
import LoginForm from "../components/LoginForm";
import "../styles/auth.css";
import { useI18n } from "../providers/I18nProvider";

const AuthPage = () => {
  const { t } = useI18n();
  useEffect(() => {
    document.body.classList.add("login-body");
    return () => {
      document.body.classList.remove("login-body");
    };
  }, []);

  return (
    <div className="auth-shell">
      <div className="auth-card" role="main">
        <div className="auth-brand" aria-hidden="true">
          <div className="auth-brand-inner">
            <img
              className="auth-logo-image"
              src={`${process.env.PUBLIC_URL}/altust_renk.png`}
              alt={t("auth.logoAlt")}
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
        <div className="auth-panel">
          <h2 className="auth-title">{t("auth.title")}</h2>
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
